import * as actionTypes from '../consts/actionTypes';

export const setPageSpecificInfo = (payload) => ({
    type: actionTypes.setRequestFormConfig,
    payload,
});

export const setHasReferrer = (dispatch, getState) => {
    const { isBrowser, scrollArray, pageType } = getState().router;
    const referrer = document.referrer;
    let payload = false;
    if (isBrowser && (pageType === 'cruisepage' || pageType === 'requestFormPage')) {
        if (
            scrollArray.length > 1 ||
            referrer.indexOf('dreamlines') !== -1 ||
            referrer.indexOf('cruiseaway') !== -1
        ) {
            payload = true;
        }
    }
    dispatch({
        type: actionTypes.setHasReferrer,
        payload,
    });
};

export const setIsLoaded = (payload: boolean = true) => (dispatch) => {
    dispatch({
        type: actionTypes.setIsLoaded,
        payload,
    });
};

export const setIsDesktop = (payload: boolean = true) => (dispatch) => {
    dispatch({
        type: actionTypes.setIsDesktop,
        payload,
    });
};
